"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var PREFIX = 'cozy-';
var cozyStorageService = {
  getItem: function getItem(key) {
    if (typeof window !== 'undefined') {
      var _localStorage;
      return (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem("".concat(PREFIX).concat(key));
    }
    return undefined;
  },
  setItem: function setItem(key, value) {
    if (typeof window !== 'undefined') {
      var _localStorage2;
      return (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.setItem("".concat(PREFIX).concat(key), value);
    }
    return undefined;
  },
  removeItem: function removeItem(key) {
    if (typeof window !== 'undefined') {
      var _localStorage3;
      return (_localStorage3 = localStorage) === null || _localStorage3 === void 0 ? void 0 : _localStorage3.removeItem("".concat(PREFIX).concat(key));
    }
    return undefined;
  }
};
var storageService = Object.create(cozyStorageService);
var _default = exports["default"] = storageService;